import { FC } from 'react';
import styled from 'styled-components';
import type { Match } from '../../../../../types';


const TopInfoMatch = styled.div`
width: 100%;
height: 20%;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
row-gap: 0px;

& .title-match {
    font-size: 5px;
    font-weight: 500;
    text-transform: uppercase;
    color: white;
    margin: 0;
    padding: 0;
    line-height: 1;
}

& .name-match {
    font-size: 5px;
    font-weight: 500;
    text-transform: uppercase;
    color: white;
    margin: 0;
    padding: 0;
    line-height: 1;
}
`;

interface TopInfoMatchRenderingProps {
    matchInfo: Match;
    typeMatch?: string;
}

const TopInfoMatchRendering: FC<TopInfoMatchRenderingProps> = ({ matchInfo, typeMatch = "Default" }) => {
    return (
        <TopInfoMatch className='top-info-match'>
            <div className='title-match'>{typeMatch}</div>
            <div className='name-match'>{matchInfo.type_match?.name}</div>
        </TopInfoMatch>
    )
}

export default TopInfoMatchRendering;
